import React, {PureComponent} from 'react'
import {inject, observer} from 'mobx-react'
import Store from 'Store'
import {TicketCashDesk} from '../Model'
import {T} from 'helpers/i18n'
import {toMoney, toPercentage, toDateTime, toRound, toPorciento} from 'helpers/Format'
import TicketsReport from '../components/TicketsReport'
import {User} from '../../Users/Model'
import history from 'helpers/History'
import Theme from 'Theme'
import {Button, Card, CardBody, CardHeader, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap'
import QRCodeSVG from '../../../elements/QRCode'

interface Props {
  store?: Store
}

@inject('store')
@observer
class TicketCashDeskDetail extends PureComponent<Props, object> {
  users: User[]

  UNSAFE_componentWillMount() {
    console.log('UNSAFE_componentWillMount')
    if (history.location.state === undefined) {
      history.goBack()
    }
  }

  componentDidMount() {
    console.log('TicketGratis - componentDidMount')
    this.props.store!.reports.readTicketGratis()
  }

  findUser = (lista, id: number) => {
    const result = lista.find(value => value.id === id)
    return result ? result.name : ''
  }

  handleOnSelectItem = (item) => {
    console.error((item as any).id)
  }

  toggle = () => {
    history.goBack()
  }

  render() {
    const item: TicketCashDesk | any = history.location.state
    console.log('item: ', item)
    const ticketPrinted = typeof item.refundTickets === 'string'? JSON.parse(item.printedTickets).printed : item.printedTickets.printed
    const ticketRefunded = typeof item.refundTickets === 'string'? JSON.parse(item.refundTickets).refunded : item.refundTickets.refunded
    const {reports} = this.props.store!
    const items = reports.ticketGratis
    const image = `${process.env.REACT_APP_SERVER}${item.image}`
    const externalCloseBtn =
      <button
        className="close"
        style={{color: Theme.color.primary, position: 'absolute', top: '50px', right: '15px'}}
        onClick={this.toggle}>
        &times;
      </button>

    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Modal
              centered
              fade
              isOpen={true}
              modalTransition={{timeout: 700}}
              backdropTransition={{timeout: 1000}}
              toggle={this.toggle}
              /*external={externalCloseBtn}*/
              style={{width: '320px'}}
            >
              <ModalHeader>{`Cierre de caja`}</ModalHeader>
              <ModalBody>

                <p style={{
                  marginBottom: '5px',
                  width: '100%',
                  height: '1px',
                  background: 'black',
                }}
                >
                  {''}
                </p>

                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>

                  {/*---------------------------------------------------------------------*/}
                  {/*Apertura*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start'
                  }}>
                    <p style={{marginBottom: 0, fontWeight: 'bold'}}>
                      {'Apertura: '}
                    </p>
                    <p style={{marginBottom: 0, marginLeft: '10px'}}>
                      {` ${item.dateOpen}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*Cierre*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start'
                  }}>
                    <p style={{marginBottom: 0, fontWeight: 'bold'}}>
                      {'Cierre: '}
                    </p>
                    <p style={{marginBottom: 0, marginLeft: '10px'}}>
                      {` ${item.dateClose}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*Operario*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start'
                  }}>
                    <p style={{marginBottom: 0, fontWeight: 'bold'}}>
                      {'Operario:'}
                    </p>
                    <p style={{marginBottom: 0, marginLeft: '10px'}}>
                      {` ${item.username}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*TerminalBrand*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}>
                    <p style={{marginBottom: 0, fontWeight: 'bold'}}>
                      {'Dispositivo: '}
                    </p>
                    <p style={{marginBottom: 0, marginLeft: '10px'}}>
                      {` ${item.terminalBrand}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*TerminalSN*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end'
                  }}>
                    <p style={{marginLeft: '10px', fontWeight: 'bold'}}>
                      {` ${item.terminalSN}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*Total*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}>
                    <p style={{marginBottom: 0, fontWeight: 'bold'}}>
                      {'TOTAL: '}
                    </p>
                    <p style={{marginBottom: 0, marginLeft: '10px'}}>
                      {` ${item.total}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*Descuento*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}>
                    <p style={{marginBottom: 0, fontWeight: 'bold'}}>
                      {'DESCUENTO: '}
                    </p>
                    <p style={{marginBottom: 0, marginLeft: '10px'}}>
                      {` ${item.totalDiscount}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*Checkins*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}>
                    <p style={{marginBottom: 0, fontWeight: 'bold'}}>
                      {'CHECKINS: '}
                    </p>
                    <p style={{marginBottom: 0, marginLeft: '10px'}}>
                      {` ${item.checkins}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*Tickets printed*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}>
                    <p style={{marginBottom: 0, fontWeight: 'bold'}}>
                      {'TICKETS: '}
                    </p>
                    <p style={{marginBottom: 0, marginLeft: '10px'}}>
                      {` ${ticketPrinted.length}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*Tickets refunded*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}>
                    <p style={{marginBottom: 0, fontWeight: 'bold'}}>
                      {'DEVOLUCIONES: '}
                    </p>
                    <p style={{marginBottom: 0, marginLeft: '10px'}}>
                      {` ${ticketRefunded.length}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*Total abonado*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}>
                    <p style={{fontWeight: 'bold'}}>
                      {'TOTAL ABONADO: '}
                    </p>
                    <p style={{marginLeft: '10px'}}>
                      {` ${item.totalRefund}`}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}
                  {/*Lista de ventas*/}

                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                  }}>
                    <p style={{fontWeight: 'bold'}}>
                      {'LISTA DE VENTAS'}
                    </p>
                  </div>

                  {/*---------------------------------------------------------------------*/}

                  {item.lines.map(line =>
                    <div key={line.id} style={{display: 'flex', flexDirection: 'column'}}>
                      <div style={{
                        width: '275px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start'
                      }}>
                        <p style={{marginBottom: 0, }}>{`${line.quantity}x`}</p>
                        <p style={{marginBottom: 0, marginLeft: '5px'}}>{line.passengerCategory}</p>
                      </div>

                      <div style={{
                        width: '275px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                      }}>
                        <p style={{marginBottom: 0, textAlign: 'center'}}>{line.operationLine}</p>
                        <p style={{marginBottom: 0, textAlign: 'center'}}>{line.stretch}</p>
                      </div>

                      {line.totalDiscount > 0 && <div style={{
                        width: '275px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end'
                      }}>
                        <p style={{marginBottom: 0, textAlign: 'end', width: '200px'}}>{`Descuento: ${line.totalDiscount} ${line.money}`}</p>
                      </div>}

                      <div style={{
                        width: '275px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end'
                      }}>
                        <p style={{textAlign: 'end', width: '100px'}}>{`Total: ${line.total} ${line.money}`}</p>
                      </div>
                    </div>
                  )}
                  <p style={{
                    marginBottom: '5px',
                    width: '100%',
                    height: '1px',
                    background: 'black',
                  }}
                  >
                    {''}
                  </p>
                </div>
              </ModalBody>
            </Modal>
          </Col>
        </Row>
      </div>
    )
  }
}

export default TicketCashDeskDetail



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/containers/TicketCashDeskDetail.tsx